import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const BillingReturn = () => {
  return (
    <PrintPreferenceTabs type="billing_return"></PrintPreferenceTabs>
  );
};
export default BillingReturn;
